import * as React from 'react';
import { observer } from 'mobx-react';
import TrialLandingPage from '../../mainv3/containers/trial/TrialLandingPage';

/**
 * A wrapper component for trial landing pages.
 * Exists for testing several variants depending on the Optimize experiments
 */
@observer
export class TrialLp extends React.Component {
    render() {
        return <TrialLandingPage />;
    }
}
